import elon from "assets/images/elon.jpg";
import kimbal from "assets/images/kimbal.jpg";
import bezos from "assets/images/bezos.jpg";
import timemachine from "assets/images/timemachine.jpg";

const RESULT = {
  elon: {
    title: "일론 머스크",
    src: elon,
    ogTitle: "나는 아마도 일론 머스크?",
    ogDescription: "일론 머스크의 모든 것을 아는 나",
    ogImage: elon,
  },
  kimbal: {
    title: "킴벌 머스크",
    src: kimbal,
    ogTitle: "나는 아마도 일론 머스크의 동생?",
    ogDescription: "일론 머스크에 대해 이 정도까지 안다면 동생이나 다름없죠",
    ogImage: kimbal,
  },
  bezos: {
    title: "제프 베조스",
    src: bezos,
    ogTitle: "나는 아마도 일론 머스크의 천적?",
    ogDescription: "음... 설마??",
    ogImage: bezos,
  },
  timemachine: {
    title: "과거에서 온 사람",
    src: timemachine,
    ogTitle: "혹시 과거에서 오셨나요??",
    ogDescription: "실존하는 아이언맨에 대해 많이 모르시는 것 같아요.",
    ogImage: timemachine,
  },
};

export default RESULT;
